export default "__VITE_ASSET__B242pkaW__"